export interface UserValidationInfo {
  username: string;
  email: string;
}
